import { PepsAndSanctionsPartiesComponent } from "projects/reg-hub-client/src/app/orders/peps-and-sanctions-parties/peps-and-sanctions-parties.component";
import { Step, StepValidationState } from "../../../../../interfaces/step";
import { Stepper } from "../../../../../interfaces/stepper";
import { PepsAndSanctionsReviewComponent } from "projects/reg-hub-client/src/app/orders/peps-and-sanctions-review/peps-and-sanctions-review.component";

export class PEPsAndSanctionsStepper implements Stepper {

    steps: Step[];

    constructor() {
        this.steps = [
            { title: "Criteria", content: PepsAndSanctionsPartiesComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: PepsAndSanctionsReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}